import type { FC } from "react";
import type { TooltipProps } from "react-tooltip";
import ReactTooltip from "react-tooltip";

export const KibelaTooltip: FC<TooltipProps> = (props) => {
  return <ReactTooltip {...props} />;
};

export const showTooltip = (target) => ReactTooltip.show(target);

export const rebuildTooltip = () => ReactTooltip.rebuild();
